import * as tslib_1 from "tslib";
import React from 'react';
export const FloatingLabelWrapper = ({ state, className, prefix, disabled, children, }) => {
    return (React.createElement("div", { className: `flabel${className ? ` ${className}` : ''}${state.isFilled ? ' filled' : ''}${state.hasFocus ? ' on' : ''}${disabled ? ' disabled' : ''}`, "data-prefix": prefix }, children));
};
export const FloatingLabel = (_a) => {
    var { id, label, icon, children } = _a, wrapperProps = tslib_1.__rest(_a, ["id", "label", "icon", "children"]);
    return (React.createElement(FloatingLabelWrapper, Object.assign({}, wrapperProps),
        React.createElement("label", { className: "flabel-title", htmlFor: id }, label),
        React.createElement("div", { className: "flabel-value" }, children),
        icon && React.createElement("div", { className: "flabel-icon" }, icon)));
};
//# sourceMappingURL=FloatingLabel.js.map